import { Component, Input, Output, EventEmitter } from '@angular/core';

import { UploadState } from '@app/api/models/media.models';

@Component({
  selector: 'uploading-card',
  templateUrl: './uploading-card.component.html',
  styleUrls: ['./uploading-card.component.scss'],
  standalone: false,
})
export class UploadingCardComponent {
  @Output() tryAgainEmitter = new EventEmitter<void>();
  @Input() uploadingState: UploadState;
  uploadingStates = UploadState;

  tryAgain() {
    this.tryAgainEmitter.emit();
  }
}
